module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipt_info"
  }, [_c('div', {
    staticClass: "changead"
  }, [_c('div', {
    staticClass: "inputdata"
  }, [_c('div', {
    staticClass: "changeadinput"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("发票类型：")]), _vm._v(" "), (_vm.infoData.receipt_type == 1) ? _c('strong', [_vm._v("增值税普通发票")]) : _vm._e(), _vm._v(" "), (_vm.infoData.receipt_type == 2) ? _c('strong', [_vm._v("增值税专用发票")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', [_vm._v("开票类型：")]), _vm._v(" "), (_vm.infoData.type == 1) ? _c('strong', [_vm._v("个人")]) : _vm._e(), _vm._v(" "), (_vm.infoData.type == 2) ? _c('strong', [_vm._v("公司")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', [_vm._v("金额：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.total_money) + " 元")])]), _vm._v(" "), (_vm.infoData.type == 1) ? _c('li', [_c('span', [_vm._v("发票个人名称：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.user_name))])]) : _vm._e(), _vm._v(" "), (_vm.infoData.type == 1) ? _c('li', [_c('span', [_vm._v("发票个人身份证号：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.user_id_number))])]) : _vm._e(), _vm._v(" "), (_vm.infoData.type == 1) ? _c('li', [_c('span', [_vm._v("发票个人电话：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.user_phone))])]) : _vm._e(), _vm._v(" "), (_vm.infoData.type == 2) ? _c('li', [_c('span', [_vm._v("公司名称：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.company_name))])]) : _vm._e(), _vm._v(" "), (_vm.infoData.type == 2) ? _c('li', [_c('span', [_vm._v("公司纳税人识别号：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.pay_taxes_number))])]) : _vm._e(), _vm._v(" "), (_vm.infoData.type == 2) ? _c('li', [_c('span', [_vm._v("公司地址和电话：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.address_phone))])]) : _vm._e(), _vm._v(" "), (_vm.infoData.type == 2) ? _c('li', [_c('span', [_vm._v("公司开户行和账号：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.bank_number))])]) : _vm._e(), _vm._v(" "), (_vm.infoData.receipt_type == 2) ? _c('li', {
    staticStyle: {
      "width": "43%",
      "float": "left"
    }
  }, [_c('span', [_vm._v("营业执照：")]), _c('img', {
    attrs: {
      "src": _vm.infoData.license_pic,
      "alt": "点击查看大图"
    },
    on: {
      "click": function($event) {
        return _vm.aipImgLic()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.infoData.receipt_type == 2) ? _c('li', {
    staticStyle: {
      "width": "45%",
      "float": "left"
    }
  }, [_c('span', [_vm._v("一般纳税人证明：")]), _c('img', {
    attrs: {
      "src": _vm.infoData.prove_pic,
      "alt": "点击查看大图"
    },
    on: {
      "click": function($event) {
        return _vm.aipImgPro()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("配送方式：")]), _vm._v(" "), (_vm.infoData.send_type == 1) ? _c('strong', [_vm._v("自取")]) : _vm._e(), _vm._v(" "), (_vm.infoData.send_type == 2) ? _c('strong', [_vm._v("邮寄")]) : _vm._e()]), _vm._v(" "), (_vm.infoData.send_type == 2) ? _c('li', [_c('span', [_vm._v("寄送人姓名：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.send_name))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("寄送地址：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.send_address))])]), _vm._v(" "), (_vm.infoData.send_type == 2) ? _c('li', [_c('span', [_vm._v("寄送人电话：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.send_phone))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("创建时间：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.create_time))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("联系人姓名：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.drawer_name))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("联系人电话：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.drawer_phone))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("状态：")]), _vm._v(" "), (_vm.infoData.status == 0) ? _c('strong', [_vm._v("未开")]) : _vm._e(), _vm._v(" "), (_vm.infoData.status == 1) ? _c('strong', [_vm._v("已开")]) : _vm._e(), _vm._v(" "), (_vm.infoData.status == 2) ? _c('strong', [_vm._v("已取")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', [_vm._v("户号：")]), _c('strong', [_vm._v(_vm._s(_vm.infoData.account))])])]), _vm._v(" "), _c('div', {
    staticClass: "receipt_info_lists"
  }, [_c('span', [_vm._v("开票内容：")]), _vm._v(" "), _c('ul', {
    staticClass: "receipt_month"
  }, _vm._l((_vm.infoData.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.time))]), _vm._v(" ：\n\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(item.pay_type))]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(item.total_money) + " 元")])])
  }), 0)]), _vm._v(" "), _c('el-button', {
    staticClass: "receipt_close_button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.closeInfo()
      }
    }
  }, [_vm._v("关闭")])], 1), _vm._v(" "), (_vm.imgBigShow) ? _c('div', {
    staticClass: "big_img"
  }, [_c('img', {
    staticStyle: {
      "width": "25px",
      "height": "auto",
      "margin": "0",
      "position": "absolute",
      "right": "5px",
      "top": "5px"
    },
    attrs: {
      "src": require("../assets/close_white.png")
    },
    on: {
      "click": _vm.closeBigImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "big_img_close"
  }, [_c('img', {
    attrs: {
      "src": _vm.bigImg,
      "alt": "点击查看大图"
    },
    on: {
      "click": function($event) {
        return _vm.aipImgLic()
      }
    }
  })])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-41dcd00a"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/receiptInfo.vue
// module id = 529
// module chunks = 1